import f from '@qnpm/react-native-ext-fetch';
// import invalidLoginCodeMap from '../constant/invalidLoginCodeMap';
// import * as loginUtil from './loginUtil';
import getClientJson from './getClientJson';
import { qav } from '../Utils/qav';
import {DeviceInfo} from "qunar-react-native"
const {isWeb,isMini} = DeviceInfo;
import Util from "../Utils/util";
const { getBizVersion } = Util;

// 全局请求拦截，如果发现状态码是登录实现，则自动唤起登录
// f.response((res) => {
//     const { status } = res;
//     if (invalidLoginCodeMap[status]) {
//         loginUtil.delayLogin();
//     }
//     return res;
// });

const defaultParams = {
    withCredentials: true,
    body: {}
};

const fetch = async (options: any, getAbort?: any, hyId?:string) => {
    const requestParams = {
        ...defaultParams,
        ...options
    };
    // 小程序接口需要的参数
    if(isMini && DeviceInfo?.platform?.toUpperCase() === 'WECHAT'){
        const userData = wx.getStorageSync('UserData')
        const systemInfo = wx.getSystemInfoSync();
        requestParams.body.openId = userData?.user?.openId
        requestParams.body.unionId = userData?.user?.unionId
        requestParams.body.version = systemInfo?.version
        requestParams.body.weChatPlatform = 'wechat$$$small'
    }
    // console.log(requestParams);
    let clientJsonObj,extMap;
    try {
        clientJsonObj = await getClientJson(hyId || 'cmn_order_rn');
        extMap = await getBizVersion('hotel_rn');
        clientJsonObj.extMap = extMap;
    } catch (err) {
        clientJsonObj = {};
    }
    if(isWeb){
        clientJsonObj.type = 'touch'
    }
    else if(isMini){
        clientJsonObj.type = 'weChat'
    }
    const clientJson = JSON.stringify(clientJsonObj);
    requestParams.body = requestParams.body || {};
    // if(!requestParams.body.clientJson){
        requestParams.body.clientJson = clientJson;
    // }
    // if(!requestParams.requestType){
        requestParams.requestType = 'form'
    // }

     qav({
        page: "pageName",
        module: 'orderTempt',
        param:JSON.stringify(requestParams)
    });

    const promise = f(requestParams);
    // 下发abort函数
    if (getAbort) {
        getAbort(() => {
            return promise.cancel('abort');
        });
    }

    return new Promise((resolve, reject) => {
        promise
            .then((res: any) => {
                // console.log(res);
                // QRN EXT 提供的qFetch 在接口404的情况下不会throw error
                if (res.ok === false) {
                    reject(new Error(res.statusText));
                } else {
                    resolve(res);
                }
            })
            .catch((err: any) => {
                reject(err);
            });
    });
};
// global.$fetch = $fetch;
export { fetch };
